import { InvigilatorService } from "Services/invigilatorService";
import AddInvigilator from "components/Modals/AddInvigilator.modal";
import InvigilatorTable from "components/Tables/Ingilator.table";
import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";

export default function Invigilator() {

    const [showAddInvigilator, setShowAddInvigilator] = useState<boolean>(false);
    const [invigilator, setInvigilator] = useState<any>();


    const getAllInvigilator = async () => {
        await InvigilatorService.getAllInvigilator().then((res) => {
            if (res.status === 200) {
                setInvigilator(res.data.data.invigilator)
            }
        })
    }


    useEffect(() => {
        getAllInvigilator();
    }, [])

    return (
        <>
            <div className="py-4">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
                    <div>
                        <h5 className="mb-1 fw-bold">Invigilator</h5>
                        <span className="text-muted fs-12">
                            Manage invigilators · {invigilator?.length || 0} total
                        </span>
                    </div>
                    <Button onClick={() => setShowAddInvigilator(true)}>Add Invigilator</Button>
                </div>
                <Card className="xrg-card xrg-table-card shadow-sm">
                    <Card.Body className="p-0">
                        <InvigilatorTable tableData={invigilator} reload={getAllInvigilator} />
                    </Card.Body>
                </Card>

            </div>


            <AddInvigilator
                show={showAddInvigilator}
                handleClose={() => setShowAddInvigilator(false)}
                reload={getAllInvigilator}
            />
        </>
    )
}